import './styles.scss';
import {
    IconAlphabetLatin, IconHash, IconPhone, IconMail, IconUser, IconLink,
    IconChevronDown, IconListCheck, IconToggleRight, IconGauge,
    IconCalendar, IconCalendarTime, IconCoin, IconPhoto, IconVideo,
    IconBarbell, IconGenderBigender, IconRun,
} from '@tabler/icons-react';
import FormConfig from './components/FormConfig';
import StepConfig from './components/StepConfig';

// Labels are resolved at call time so they follow the active language; the
// `type` of each entry is the API keyword and must never be translated.
export const getQuestionTypes = (t) => [
    { type: 'text', label: t('builder.questionTypes.text'), Icon: IconAlphabetLatin, defaultLabel: '' },
    { type: 'full_name', label: t('builder.questionTypes.fullName'), Icon: IconUser, defaultLabel: t('builder.questionDefaults.fullName') },
    { type: 'email', label: t('builder.questionTypes.email'), Icon: IconMail, defaultLabel: t('builder.questionDefaults.email') },
    { type: 'phone', label: t('builder.questionTypes.phone'), Icon: IconPhone, defaultLabel: t('builder.questionDefaults.phone') },
    { type: 'number', label: t('builder.questionTypes.number'), Icon: IconHash, defaultLabel: '' },
    { type: 'url', label: t('builder.questionTypes.url'), Icon: IconLink, defaultLabel: '' },
    { type: 'select', label: t('builder.questionTypes.select'), Icon: IconChevronDown, defaultLabel: '', hidden: true },
    { type: 'choices', label: t('builder.questionTypes.choices'), Icon: IconListCheck, defaultLabel: '' },
    { type: 'yes_no_maybe', label: t('builder.questionTypes.yesNoMaybe'), Icon: IconToggleRight, defaultLabel: '' },
    { type: 'scale', label: t('builder.questionTypes.scale'), Icon: IconGauge, defaultLabel: '' },
    { type: 'date', label: t('builder.questionTypes.date'), Icon: IconCalendar, defaultLabel: t('builder.questionDefaults.date') },
    { type: 'datetime', label: t('builder.questionTypes.datetime'), Icon: IconCalendarTime, defaultLabel: '' },
    { type: 'monetary', label: t('builder.questionTypes.monetary'), Icon: IconCoin, defaultLabel: '' },
    { type: 'photo', label: t('builder.questionTypes.photo'), Icon: IconPhoto, defaultLabel: t('builder.questionDefaults.photo'), comingSoon: true },
    { type: 'video', label: t('builder.questionTypes.video'), Icon: IconVideo, defaultLabel: t('builder.questionDefaults.video'), comingSoon: true },
    { type: 'weight', label: t('builder.questionTypes.weight'), Icon: IconBarbell, defaultLabel: t('builder.questionDefaults.weight') },
    { type: 'gender', label: t('builder.questionTypes.gender'), Icon: IconGenderBigender, defaultLabel: t('builder.questionDefaults.gender') },
    { type: 'body_structure', label: t('builder.questionTypes.bodyStructure'), Icon: IconRun, defaultLabel: t('builder.questionDefaults.bodyStructure') },
];

export default function RightPanel({
    selectedStep, stepNumber, updateStep,
    addQuestion, updateQuestion, removeQuestion, reorderQuestions,
    onDeselect,
    communityId,
    formName, setFormName, formActive, setFormActive,
    redirectChoice, setRedirectChoice,
    returnUrl, setReturnUrl,
    allowMultipleAnswers, setAllowMultipleAnswers,
    banner, setBanner,
    theme, setTheme,
    actions, addAction, removeAction,
    errors, clearError,
    scrollSignal,
}) {
    const formErrors = errors?.form ?? {};
    const stepErrors = selectedStep ? (errors?.steps?.[selectedStep.id] ?? {}) : {};

    if (!selectedStep) {
        return (
            <FormConfig
                communityId={communityId}
                formName={formName}
                setFormName={setFormName}
                formActive={formActive}
                setFormActive={setFormActive}
                redirectChoice={redirectChoice}
                setRedirectChoice={setRedirectChoice}
                allowMultipleAnswers={allowMultipleAnswers}
                setAllowMultipleAnswers={setAllowMultipleAnswers}
                returnUrl={returnUrl}
                setReturnUrl={setReturnUrl}
                banner={banner}
                setBanner={setBanner}
                theme={theme}
                setTheme={setTheme}
                actions={actions}
                addAction={addAction}
                removeAction={removeAction}
                formErrors={formErrors}
                clearError={clearError}
                scrollSignal={scrollSignal}
            />
        );
    }

    return (
        <StepConfig
            selectedStep={selectedStep}
            stepNumber={stepNumber}
            updateStep={updateStep}
            addQuestion={addQuestion}
            updateQuestion={updateQuestion}
            removeQuestion={removeQuestion}
            reorderQuestions={reorderQuestions}
            onDeselect={onDeselect}
            stepErrors={stepErrors}
            clearError={clearError}
            scrollSignal={scrollSignal}
        />
    );
}
